/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";

const is = require("is_js");

const SERVICE_NAME = "DiscountCouponListService";
const log: any = LoggerModule.getInstance();

export class DiscountCouponListService {
  private static instance: DiscountCouponListService;
  private criteria: any;

  private constructor(props: any = {}) { }
  public static getInstance(props: any = {}): DiscountCouponListService {
    if (!DiscountCouponListService.instance) {
      DiscountCouponListService.instance = new DiscountCouponListService(
        props
      );
    }
    return DiscountCouponListService.instance;
  }
  private setCriteria(data: any) {
    this.criteria = data;
  }

  public resetCriteria() {
    this.criteria = null;
  }
  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }


  public async getDiscountCouponList(args?: any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();
    if (args) {
      this.setCriteria(args);
    }
    compProps = await agent?.getDiscountCouponList(args);
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }


}
